var Backbone = require('backbone');


var DocumentModel = Backbone.Model.extend({

    urlRoot: '/api/document'

});


module.exports = DocumentModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/document-model.js
// module id = 207
// module chunks = 0